import AppStorage from '@Services/AppStorage';

export const HEATMAP_SETTINGS_STORAGE = 'heatmapSettings';

export const getCurrentSettingsFromAppStorage = () => AppStorage.instance.get(HEATMAP_SETTINGS_STORAGE);

export const setCurrentSettingsToAppStorage = (settings) => {
  AppStorage.instance.set(HEATMAP_SETTINGS_STORAGE, settings);
};
